module.exports = __webpack_public_path__ + "img/case-img.02cd6512.png";